/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { Store } from '@ngrx/store';
import { SystemManagerState } from './system-manager-reducer';
import {
  BrowseClick,
  GetReturnCodeAfterExport,
  GetVisibleInvisibleSystems,
  onSystemManagerItemClickAction,
} from './system-manager-actions';
import { Observable, from, map } from 'rxjs';
import { selectExportReturnCodes, selectFileName, selectVisibleInvisibleSystems } from './system-manager-selector';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { ISystemManagerFacade } from '../../../../../data-access/src/lib/domain/facades-models/system-manager-facade-interface';
import { SystemManagerExportReturnCodes } from '../../../../../../shared/ui/src/lib/enums/system-manager-export-return-codes';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { GlobalConstants } from '../../constants/global-constants';
import { SysqueElectricalState } from '../../models/sysque-electrical-state';
import { SystemOptionsReturnCodes } from '../../sysque-system-category-options/sysque-system-category-options.component';
import { CallsService } from '../../../../../utils/src/lib/backend-calls/calls-backend-service';

@Injectable({ providedIn: 'root' })
export class SystemManagerFacade implements ISystemManagerFacade {
  constructor(
    private backendService: BackendService,
    private service: CallsService,
    private store: Store<SystemManagerState>,
    private localStorageService: LocalStorageService
  ) {}

  public onWindowResize(height: number): void {
    this.service.onWindowResize(GlobalConstants.ChangeHeight, height);
  }

  public getVisibleInvisibleSystems(): Observable<SystemInfo[]> {
    this.store.dispatch(GetVisibleInvisibleSystems());
    return this.store.select(selectVisibleInvisibleSystems);
  }

  public onExportClick(selectedSystems: string[]): Observable<SystemManagerExportReturnCodes> {
    this.store.dispatch(GetReturnCodeAfterExport({ selectedSystems }));
    return this.store.select(selectExportReturnCodes);
  }

  public onSystemManagerItemClick(route: string, width: number, height: number): void {
    if (!!height && !!width) {
      this.store.dispatch(onSystemManagerItemClickAction({ route: route, width: width, height: height }));
    }
  }
  
  public browseFile(): Observable<string> {
    this.store.dispatch(BrowseClick());
    return this.store.select(selectFileName).pipe(
        map(filename => {
          console.log('facade', filename);
          return filename;
        })
    );
  }

  public updateLocalStorage(key: string, value: any): void {
    this.localStorageService.updateDispatchLocalStorage(key, value);
  }

  public getState(): SysqueElectricalState {
    return this.localStorageService.getStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
  }

  public saveSystemsChanges(systems: SystemInfo[]): Observable<SystemOptionsReturnCodes> {
    return from<Promise<SystemOptionsReturnCodes>>(
      this.backendService.messageHandler.sendRequestAsync(GlobalConstants.SaveSystemsChanges, [systems])
    );
  }
}
